import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
    currentUser: any | null;
    isLoggedIn: boolean;
    registeredUsers: any[]; // This acts as our fake database
    signup: (userData: any) => { success: boolean; message?: string };
    login: (credentials: any) => { success: boolean; message?: string };
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            currentUser: null,
            isLoggedIn: false,
            registeredUsers: [], // Starts empty

            signup: (userData) => {
                const { registeredUsers } = get();
                
                // 1. Check if email is already registered
                if (registeredUsers.find(user => user.email === userData.email)) {
                    return { success: false, message: 'An account with this email already exists.' };
                }
                
                // 2. Save user to "database" and log them in
                set({
                    registeredUsers: [...registeredUsers, userData],
                    currentUser: userData,
                    isLoggedIn: true
                });
                return { success: true };
            },

            login: (credentials) => {
                const { registeredUsers } = get();
                
                // 1. Search the "database" for a matching email AND password
                const user = registeredUsers.find(
                    u => u.email === credentials.email && u.password === credentials.password
                );
                
                // 2. If match, log them in. If not, return an error.
                if (user) {
                    set({ currentUser: user, isLoggedIn: true });
                    return { success: true };
                }
                return { success: false, message: 'Invalid email or password.' };
            },

            logout: () => set({ currentUser: null, isLoggedIn: false })
        }),
        {
            name: 'oya-auth-storage', // Saves to browser LocalStorage
        }
    )
);